@import "../../variables.scss";

.timesheets_header {
  @media (min-width: $size-sm) {
    margin-bottom: 4rem;
    display: inline-block;
  }
}

.timesheets_helpText {
  border: 1px solid #d0d0d0;
  padding: 1rem;
  font-size: 0.9rem;
  @media (min-width: $size-sm) {
    max-width: 55%;
    float: right;
    margin-bottom: 60px;
  }
}
